module.exports = __webpack_public_path__ + "static/banner_my_receipt@2x-8fa65db331b9f3cb379bb0a50a277643.png";